export default __webpack_public_path__ + "static/media/TCS.NS.3b11b059.png";